// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/CoreWebVitals/Histogram.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/CoreWebVitals/Histogram.tsx");
  import.meta.hot.lastModified = "1723073005305.1667";
}
// REMIX HMR END

import clsx from "clsx";
import React from "react";
import IconResolver from "~/components/IconResolver";
const Histogram = ({
  value,
  caption,
  showP75 = false,
  segments,
  pass = null
}) => {
  const radius = 35;
  const diameter = radius * 2;
  const stroke = 3;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const colours = ["stroke-error-600", "stroke-warning-800", "stroke-secondary-600"];
  const percentile75Color = (() => {
    let count = 0;
    for (const [index, segment] of (segments || []).entries()) {
      count += segment;
      if (count >= 75) {
        return colours[colours.length - index - 1];
      }
    }
    return "#6b7280";
  })();
  const captionWithTimeUnit = value && value?.toString().replace(" ", "");
  return <div className="flex flex-col items-center w-full">
      <div className="relative rounded-full flex items-center justify-center text-xs">
        <svg height={diameter} width={diameter}>
          {[...(segments || [80])].reverse().map((segment, index) => <circle key={index} className={clsx("origin-center rotate-[270deg] fill-transparent", colours[index])} strokeDasharray={`${circumference} ${circumference}`} style={{
          strokeDashoffset: circumference - segment / 100 * circumference
        }} strokeWidth={stroke} r={normalizedRadius} cx={radius} cy={radius} />)}
          {value && showP75 && <circle className={percentile75Color} fill="white" stroke="#fff" strokeWidth="1" cx={radius} cy={radius} r={stroke} style={{
          transform: `translateX(${-1 * radius * Math.cos(270) + 5}px)`
        }} />}
        </svg>
        {captionWithTimeUnit && <span className="absolute text-neutral-600">
            {captionWithTimeUnit}
          </span>}
        {pass !== null && <div className={`absolute ${pass ? "text-secondary-600" : "text-error-600"}`}>
            <IconResolver className="h-8 w-8" token={pass ? "check" : "x"} />
          </div>}
      </div>
      <span className="text-xs text-neutral-600">{caption}</span>
    </div>;
};
_c = Histogram;
export default Histogram;
var _c;
$RefreshReg$(_c, "Histogram");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;